import { TRect } from '@/types';

function toRelativeRect(rect: TRect, originalWidth: number, originalHeight: number): TRect {
  if (originalWidth === 0 || originalHeight === 0) {
    return rect;
  }
  return [
    rect[0] / originalWidth,
    rect[1] / originalHeight,
    rect[2] / originalWidth,
    rect[3] / originalHeight,
  ];
}

function fromRelativeRect(rect: TRect, newWidth: number, newHeight: number): TRect {
  return [rect[0] * newWidth, rect[1] * newHeight, rect[2] * newWidth, rect[3] * newHeight];
}

function normalizeRect(rect: TRect): TRect {
  let [x, y, w, h] = rect;
  if (w < 0) {
    x = x + w;
    w = Math.abs(w);
  }
  if (h < 0) {
    y = y + h;
    h = Math.abs(h);
  }
  return [x, y, w, h];
}

function bboxToRect([left, top, right, bottom]: TRect): TRect {
  return [left, top, right - left, bottom - top];
}

function rectToBbox([left, top, width, height]: TRect): TRect {
  return [left, top, left + width, top + height];
}

export { fromRelativeRect, normalizeRect, toRelativeRect, bboxToRect, rectToBbox };
